export default {
    NETOMI_HANDOVER_DEPARTMENT_NAME: 'NETOMI_HANDOVER_DEPARTMENT_NAME',
    ZD_CHAT_VISITOR_NAME: 'ZD_CHAT_visitor_name',
    ZD_CHAT_VISITOR_EMAIL: 'ZD_CHAT_visitor_email',
    ZD_CHAT_VISITOR_PHONE: 'ZD_CHAT_visitor_phone',
    ZD_LIVE_HANDOFF_TAGS: 'Zendesk_live_handoff_tags',
    ZD_CHAT_CLEAR_TAGS: 'ZD_CHAT_clear_tags',
    DISABLE_CHAT_INPUT_FIELD: 'DISABLE_CHAT_INPUT',
    DISABLE_INPUT_FIELD: 'DISABLE_INPUT_FIELD',
    END_CHAT_FIELD: 'END_CHAT',
    FORM_URL: 'FORM_URL',
    FORM_ID: 'FORM_ID',
    FORMID: 'FORMID',
    CALLBACK_EVENT: 'CALLBACK_EVENT',
    CALLBACKEVENT: 'CALLBACKEVENT',
    FORM_SCHEMA: 'FORM_SCHEMA',
    SURVEY_SCHEMA: 'SURVEY_SCHEMA',
    PRIMARY_LANGUAGE: 'PRIMARY_LANGUAGE'
}